import addWeeklyPlan from './index.vue'
export default addWeeklyPlan